import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import serviceUnitGeoprocessing from './serviceUnitGeoprocessingRead.action.json' assert { type: 'json' }

const serviceUnitGeoprocessingReadDefinition = defineReadAutoAction(
  serviceUnitGeoprocessing,
  'serviceUnitGeoprocessing',
)

export default serviceUnitGeoprocessingReadDefinition
